<template>
  <div class="content">
    <div class="md-layout">
    <div class="md-layout-item md-size-100 md-xsmall-size-50">
      <label for="rod">Podaci od</label>
      <div class="md-layout-item md-size-33">      
          <md-field>
            <label for="rod">Godina</label>
            <md-select
              v-model="date_filter.start_year">
              <md-option value="2020">2020</md-option>
              <md-option value="2021">2021</md-option>
              <md-option value="2022">2022</md-option>
              <md-option value="2023">2023</md-option>
              <md-option value="2024">2024</md-option>
              <md-option value="2025">2025</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-33">      
          <md-field>
            <label for="rod">Mjesec</label>
            <md-select
              v-model="date_filter.start_month">
              <md-option value="1">Jan</md-option>
              <md-option value="2">Feb</md-option>
              <md-option value="3">Mar</md-option>
              <md-option value="4">Apr</md-option>
              <md-option value="5">Maj</md-option>
              <md-option value="6">Jun</md-option>
              <md-option value="7">Jul</md-option>
              <md-option value="8">Aug</md-option>
              <md-option value="9">Sep</md-option>
              <md-option value="10">Okt</md-option>
              <md-option value="11">Nov</md-option>
              <md-option value="12">Dec</md-option>
            </md-select>
          </md-field>
        </div>
      <button @click="start_resort">Osvježi podatke</button>
    </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
        v-if="show_top_negatori"
      >
        <chart-card
          :chart-data="top_negatori.data"
          :chart-options="top_negatori.options"
          :chart-responsive-options="top_negatori.responsiveOptions"
          :chart-type="'Bar'"
          data-background-color="red"
        >
          <template slot="content">
            <h4 class="title">Top Negatori</h4>
            <p class="category">
              Najčešći jedinstveni slučajevi negiranja genocida
            </p>

          </template>
          <template slot="footer">
            <download-csv class="category"
              :data   = "top_negatori.downloadable">
              Skini Podatke
          </download-csv>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
        v-if="show_top_platforme"
      >
        <chart-card
          :chart-data="top_platforme.data"
          :chart-options="top_platforme.options"
          :chart-responsive-options="top_platforme.responsiveOptions"
          :chart-type="'Bar'"
          data-background-color="green"
        >
          <template slot="content">
            <h4 class="title">Top Platforme</h4>
            <p class="category">
              
            </p>
          </template>
          <template slot="footer">
            <download-csv class="category"
              :data   = "top_platforme.downloadable">
              Skini Podatke
          </download-csv>
          </template>

        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
        v-if="show_top_lokacije"
      >
        <chart-card
          :chart-data="top_lokacije.data"
          :chart-options="top_lokacije.options"
          :chart-responsive-options="top_lokacije.responsiveOptions"
          :chart-type="'Bar'"
          data-background-color="green"
        >
          <template slot="content">
            <h4 class="title">Top Lokacije</h4>
          </template>


          <template slot="footer">
            <download-csv class="category"
              :data   = "top_lokacije.downloadable">
              Skini Podatke
          </download-csv>
          </template>        
          </chart-card>
      </div>

       <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
        v-if="show_top_nacini"
      >
        <chart-card
          :chart-data="nacini_negiranja.data"
          :chart-options="nacini_negiranja.options"
          :chart-responsive-options="nacini_negiranja.responsiveOptions"
          :chart-type="'Bar'"
          data-background-color="green"
        >
          <template slot="content">
            <h4 class="title">Top Načini Negiranja</h4>

          </template>

          <template slot="footer">
            <download-csv class="category"
              :data   = "nacini_negiranja.downloadable">
              Skini Podatke
          </download-csv>
          </template>
        </chart-card>
      </div>
    
       <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
        v-if="show_lokacije_negatora"
      >
        <chart-card
          :chart-data="lokacije_negatora.data"
          :chart-options="lokacije_negatora.options"
          :chart-responsive-options="lokacije_negatora.responsiveOptions"
          :chart-type="'Bar'"
          data-background-color="green"
        >
          <template slot="content">
            <h4 class="title">Zemlje porijekla negatora</h4>
          </template>

          <template slot="footer">                      
            <download-csv class="category"
              :data   = "lokacije_negatora.downloadable">
              Skini Podatke
          </download-csv>
          </template>
        </chart-card>
      </div>

       <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
        v-if="show_sektori_negatora"
      >
        <chart-card
          :chart-data="sektori_negatora.data"
          :chart-options="sektori_negatora.options"
          :chart-responsive-options="sektori_negatora.responsiveOptions"
          :chart-type="'Bar'"
          data-background-color="green"
        >
          <template slot="content">
            <h4 class="title">Sektori negatora</h4>
          </template>

          <template slot="footer">                      
            <download-csv class="category"
              :data   = "sektori_negatora.downloadable">
              Skini Podatke
          </download-csv>
          </template>
        </chart-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
        v-if="show_oblasti_negatora"
      >
        <chart-card
          :chart-data="oblast_negatora.data"
          :chart-options="oblast_negatora.options"
          :chart-responsive-options="oblast_negatora.responsiveOptions"
          :chart-type="'Bar'"
          data-background-color="green"
        >
          <template slot="content">
            <h4 class="title">Oblast negatora</h4>
          </template>

          <template slot="footer">                      
            <download-csv class="category"
              :data   = "oblast_negatora.downloadable">
              Skini Podatke
          </download-csv>
          </template>
        </chart-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
        v-if="show_lokacije_platformi"
      >
        <chart-card
          :chart-data="lokacije_platformi.data"
          :chart-options="lokacije_platformi.options"
          :chart-responsive-options="lokacije_platformi.responsiveOptions"
          :chart-type="'Bar'"
          data-background-color="green"
        >
          <template slot="content">
            <h4 class="title">Lokacije platformi</h4>
          </template>
          <template slot="footer">                      
            <download-csv class="category"
              :data   = "lokacije_platformi.downloadable">
              Skini Podatke
          </download-csv>
          </template>
        </chart-card>
      </div>

      
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
        v-if="show_tip_platformi"
      >
        <chart-card
          :chart-data="tip_platformi.data"
          :chart-options="tip_platformi.options"
          :chart-responsive-options="tip_platformi.responsiveOptions"
          :chart-type="'Bar'"
          data-background-color="green"
        >
          <template slot="content">
            <h4 class="title">Tip platformi</h4>
          </template>
          <template slot="footer">                      
            <download-csv class="category"
              :data   = "tip_platformi.downloadable">
              Skini Podatke
          </download-csv>
          </template>
        </chart-card>
        
      </div>     
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
        <md-card>
          <md-card-header
          >
            Ostali podaci
          </md-card-header>

          <md-card-content>
                              
            <download-csv class="category"
              :data   = "spojeni_podaci">
              Skini Sve Spojene Podatke
          </download-csv>

            <download-csv class="category"
              :data   = "negatori_array">
              Skini Sve Negatore
          </download-csv>

            <download-csv class="category"
              :data   = "platforme_array">
              Skini Sve Platforme
          </download-csv>
          </md-card-content>

          <md-card-actions md-alignment="left">
            
          </md-card-actions>
        </md-card>

        
      </div>

    </div>
  </div>
</template>

<script>
import {
  ChartCard,  
} from "@/components";
import axios from 'axios'
import JsonCSV from 'vue-json-csv'
export default {
  components: {
    ChartCard
  },
  data() {
    return {
      dailySalesChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[12, 17, 7, 17, 23, 18, 38]]
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      dataCompletedTasksChart: {
        data: {
          labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]]
        },

        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      emailsSubscriptionChart: {
        data: {
          labels: [
            "Ja",
            "Fe",
            "Ma",
            "Ap",
            "Mai",
            "Ju",
            "Jul",
            "Au",
            "Se",
            "Oc",
            "No",
            "De"
          ],
          series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },
      show_all_graphs: true,
      cinovi_array: [],
      negatori_array: [],
      platforme_array: [],
      cinovi_dict:{},
      negatori_dict:{},
      platforme_dict:{},
      counted_negatori: {},
      counted_platforme: {},
      counted_lokacije:{},
      counted_nacini:{},
      counted_lok_negatora:{},
      counted_sektor_negatora:{},
      counted_oblast_negatora:{},
      counted_lokacije_platformi:{},
      counted_tip_platformi:{},
      spojeni_podaci:[],
      tok:"",
      top_negatori:{
        data:{
          series:[],
          labels:[]
        },        
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 12,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 20,
            left: 0
          }
        }
      },
      top_platforme:{
                data:{
          series:[],
          labels:[]
        },        
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 12,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 20,
            left: 0
          }
        }
      },
      top_lokacije:{
                data:{
          series:[],
          labels:[]
        },        
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 12,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 20,
            left: 0
          }
        }
      },
      nacini_negiranja:{        data:{
          series:[],
          labels:[]
        },        
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 12,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 20,
            left: 0
          }
        }},
      lokacije_negatora:{
      data:{
          series:[],
          labels:[]
        },        
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 12,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 20,
            left: 0
          }
        }},
      sektori_negatora:{
      data:{
          series:[],
          labels:[]
        },        
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 12,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 20,
            left: 0
          }
        }},
      oblast_negatora:{
      data:{
          series:[],
          labels:[]
        },        
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 12,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 20,
            left: 0
          }
        }},
      lokacije_platformi:{
      data:{
          series:[],
          labels:[]
        },        
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 12,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 20,
            left: 0
          }
        }},
      tip_platformi:{
      data:{
          series:[],
          labels:[]
        },        
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 12,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 20,
            left: 0
          }
        }},
      show_top_negatori: false,
      show_top_platforme:false,
      show_top_lokacije:false,
      show_top_nacini: false,
      show_lokacije_negatora: false,
      show_sektori_negatora: false,
      show_oblasti_negatora: false,
      show_lokacije_platformi: false,
      show_tip_platformi: false,
      date_filter:{
        start_year: "2023",
        start_month:"1"
      }
    };
  },
  mounted: async function()
  {
    const token = await this.$auth.getTokenSilently();
    
    axios.get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/cinovi",
      {
        headers: {
          Authorization: `Bearer ${token}`  
        }
      })
    .then(((response) => {
        this.cinovi_array = response.data
      }))
    .then(((response) => {
        this.count_cinovi();
        /* spajanje podataka */

        this.cinovi_array.forEach(element => {
          this.spojeni_podaci.push(
            {...element.cin,
            ...element.platforma,
            ...element.negator}
          )  
        });
        this.top_negatori = this.sort_by_key(this.counted_negatori, this.negatori_dict, 'negator_ime_naziv')
        this.show_top_negatori = true

        /* sorting platforme */
        this.top_platforme = this.sort_by_key(this.counted_platforme, this.platforme_dict, 'platforma_naziv')
        this.show_top_platforme = true
        /* sorting lokacije */
        this.top_lokacije = this.sort_by_value(this.counted_lokacije)
        this.show_top_lokacije = true
        /* sorting nacini */
        this.nacini_negiranja = this.sort_by_value(this.counted_nacini)        
        this.show_top_nacini = true
      }))
    

    axios.get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/negatori",
      {
        headers: {
          Authorization: `Bearer ${token}`  
        }
      })
    .then(((response) => {
      this.negatori_array = response.data.Items
      })) 
    .then(((response) => {
        this.count_negatori()

        this.lokacije_negatora = this.sort_by_value(this.counted_lok_negatora)
        this.show_lokacije_negatora = true
        /* sorting sekt negatora */

        this.sektori_negatora = this.sort_by_value(this.counted_sektor_negatora)
        this.show_sektori_negatora = true
        
        /* sorting oblast negatora */

        this.oblast_negatora = this.sort_by_value(this.counted_oblast_negatora)
        this.show_oblasti_negatora = true
      }))

    axios.get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/platforme",
      {
        headers: {
          Authorization: `Bearer ${token}`  
        }
      })
    .then(((response) => {
        this.platforme_array = response.data.Items
      })) 
    .then(((response) => {
        this.count_platforme()

        /* sorting lok platformi */
        this.lokacije_platformi = this.sort_by_value(this.counted_lokacije_platformi)
        this.show_lokacije_platformi = true

        /* sorting tip platformi */
        this.tip_platformi = this.sort_by_value(this.counted_tip_platformi)
        this.show_tip_platformi = true
      }))
  },
  methods:
  {
    count_cinovi: function()
    {
      this.counted_negatori= {}
      this.counted_platforme= {}
      this.counted_lokacije= {}
      this.counted_nacini= {}

      this.cinovi_array.forEach(el => {
      this.cinovi_dict[el.cin.uuid_cin] = el.cin
      var startFilterTime = new Date(this.date_filter.start_year+"-"+this.date_filter.start_month).getTime()
      if (new Date(el.cin.cin_datum) >= startFilterTime)
      {

          if(el.cin.cin_uuid_negator in this.counted_negatori)
          {
            this.counted_negatori[el.cin.cin_uuid_negator] += 1
          }
          else{
            this.counted_negatori[el.cin.cin_uuid_negator] = 1
          }          
          if (el.cin.cin_uuid_platforma in this.counted_platforme)
          {
            this.counted_platforme[el.cin.cin_uuid_platforma] += 1
          }
          else{
            this.counted_platforme[el.cin.cin_uuid_platforma] = 1
          }
          if (el.cin.cin_drzava in this.counted_lokacije)
          {
            this.counted_lokacije[el.cin.cin_drzava] += 1
          }
          else{
            this.counted_lokacije[el.cin.cin_drzava] = 1
          }
          if (el.cin.cin_nacin_negiranja in this.counted_nacini)
          {
            this.counted_nacini[el.cin.cin_nacin_negiranja] += 1
          }
          else{
            this.counted_nacini[el.cin.cin_nacin_negiranja] = 1
          }
        }
      });
    },
    count_negatori: function()
    {
      this.counted_lok_negatora = {}
      this.counted_sektor_negatora = {}
      this.counted_oblast_negatora = {}
        this.negatori_array.forEach(el => {
          this.negatori_dict[el.uuid_negator] = el

          if(el.negator_drzava in this.counted_lok_negatora)
          {
            this.counted_lok_negatora[el.negator_drzava] += 1
          }
          else{
            this.counted_lok_negatora[el.negator_drzava] = 1
          }          

          if(el.negator_sektor in this.counted_sektor_negatora)
          {
            this.counted_sektor_negatora[el.negator_sektor] += 1
          }
          else{
            this.counted_sektor_negatora[el.negator_sektor] = 1
          }        

          if(el.negator_oblast in this.counted_oblast_negatora)
          {
            this.counted_oblast_negatora[el.negator_oblast] += 1
          }
          else{
            this.counted_oblast_negatora[el.negator_oblast] = 1
          }          
        });
    },
    count_platforme: function()
    {
      this.counted_lokacije_platformi = {}
      this.counted_tip_platformi = {}
        this.platforme_array.forEach(el => {
          this.platforme_dict[el.uuid_platforma] = el
            
          if(el.platforma_lokacija in this.counted_lokacije_platformi)
          {
            this.counted_lokacije_platformi[el.platforma_lokacija] += 1
          }
          else{
            this.counted_lokacije_platformi[el.platforma_lokacija] = 1
          }     
          if(el.platforma_tip_medija in this.counted_tip_platformi)
          {
            this.counted_tip_platformi[el.platforma_tip_medija] += 1
          }
          else{
            this.counted_tip_platformi[el.platforma_tip_medija] = 1
          }     
        });
    },
    sort_by_key: function(counted_iterable, named_iterable, naming_key)
    {
        var sortable = [];
        for (var iter in counted_iterable)
        {
          sortable.push([iter, counted_iterable[iter]])
        }
        sortable.sort(function(a, b) {
            return b[1] - a[1];
        });

        var labeled_sortable = []
        for (let index = 0; index < sortable.length; index++) {
          var a = sortable[index]
          var value = a[1]
          var label = named_iterable[a[0]][naming_key] == undefined ? "" : named_iterable[a[0]][naming_key]
          var obj = {"Ime":label, "Zbir":value}
          labeled_sortable.push(obj)          
        }

        sortable = sortable.slice(0,10)
        var data_sortable = []
        var labels_sortable = []
        sortable.forEach(a => {
          data_sortable.push(a[1])
          labels_sortable.push(named_iterable[a[0]][naming_key])
        });
        var prepared_obj = {
        data:{
          series:[data_sortable],
          labels:labels_sortable
        },        
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: data_sortable[0] + 2,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 20,
            left: 0
          }
        },
        downloadable: labeled_sortable
      }
      return prepared_obj
    },
    sort_by_value: function(counted_iterable)
    {
        var sortable = [];
        for (var entry in counted_iterable)
        {
          sortable.push([entry, counted_iterable[entry]])
        }
        sortable.sort(function(a, b) {
            return b[1] - a[1];
        });

        var labeled_sortable = []
        for (let index = 0; index < sortable.length; index++) {
          var a = sortable[index]
          var value = a[1]
          var label = a[0]
          var obj = {"Ime":label, "Zbir":value}
          labeled_sortable.push(obj)          
        }
        sortable = sortable.slice(0,10)
        var data_sortable = []
        var labels_sortable = []
        sortable.forEach(a => {
          data_sortable.push(a[1])
          labels_sortable.push(a[0])
        });
        var prepared_obj = {
        data:{
          series:[data_sortable],
          labels:labels_sortable
        },        
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: data_sortable[0] + 2,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 20,
            left: 0
          }
        },
        downloadable: labeled_sortable
      }
      return prepared_obj
    },
    reset_to_default_sort: function()
    {
      this.count_cinovi();
      this.count_negatori()
      this.count_platforme()

      this.show_top_negatori = false
      this.show_top_platforme = false        
      this.show_top_lokacije = false
      this.show_top_nacini = false
      this.show_lokacije_negatora = false
      this.show_sektori_negatora = false
      this.show_oblasti_negatora = false        
      this.show_lokacije_platformi = false
      this.show_tip_platformi = false
      
      this.top_negatori = this.sort_by_key(this.counted_negatori, this.negatori_dict, 'negator_ime_naziv')
      

      /* sorting platforme */
      this.top_platforme = this.sort_by_key(this.counted_platforme, this.platforme_dict, 'platforma_naziv')
      
      /* sorting lokacije */
      this.top_lokacije = this.sort_by_value(this.counted_lokacije)
      /* sorting nacini */
      this.nacini_negiranja = this.sort_by_value(this.counted_nacini)        

      this.lokacije_negatora = this.sort_by_value(this.counted_lok_negatora)

      /* sorting sekt negatora */

      this.sektori_negatora = this.sort_by_value(this.counted_sektor_negatora)

      
      /* sorting oblast negatora */

      this.oblast_negatora = this.sort_by_value(this.counted_oblast_negatora)

      /* sorting lok platformi */
      this.lokacije_platformi = this.sort_by_value(this.counted_lokacije_platformi)

      /* sorting tip platformi */
      this.tip_platformi = this.sort_by_value(this.counted_tip_platformi)

    },
    // transfer mounted to methods
    /**

     * 6) resort_by_date - counts cinovi by filter condition, limits platforme and negatori to only those present in 
     *    filtere cinovi, repeats rest of process as previously
     * 7) reset_to_default_sort - repeats all actions done during mount
     * 
     */
    resort_by_date: function()
    {
      this.show_all_graphs = false;
      this.count_cinovi() // statistike od cinova cinovi su sad profiltrirani
      // pravimo nove negatori/platforme liste
      var filtrirani_cinovi_array = this.cinovi_array.filter(el => new Date(el.cin.cin_datum) 
            >= new Date(this.date_filter.start_year + "-" + this.date_filter.start_month).getTime())
      var filtrirani_negatori_array = filtrirani_cinovi_array.map(x => x.negator)
      const negatori_key = "uuid_negator"
      var unique_filtrirani_negatori = [...new Map(filtrirani_negatori_array.map(item =>
          [item[negatori_key], item])).values()];
      
      var filtrirane_platforme_array = filtrirani_cinovi_array.map(x => x.platforma)
      const platforma_key = "uuid_platforma"
      var unique_filtrirane_platforme = [...new Map(filtrirane_platforme_array.map(item =>
          [item[platforma_key], item])).values()]
      
      this.counted_lok_negatora = {}
      this.counted_sektor_negatora = {}
      this.counted_oblast_negatora = {}
      
      unique_filtrirani_negatori.forEach(el => {
          this.negatori_dict[el.uuid_negator] = el

          if(el.negator_drzava in this.counted_lok_negatora)
          {
            this.counted_lok_negatora[el.negator_drzava] += 1
          }
          else{
            this.counted_lok_negatora[el.negator_drzava] = 1
          }          

          if(el.negator_sektor in this.counted_sektor_negatora)
          {
            this.counted_sektor_negatora[el.negator_sektor] += 1
          }
          else{
            this.counted_sektor_negatora[el.negator_sektor] = 1
          }        

          if(el.negator_oblast in this.counted_oblast_negatora)
          {
            this.counted_oblast_negatora[el.negator_oblast] += 1
          }
          else{
            this.counted_oblast_negatora[el.negator_oblast] = 1
          }          
        });

      
      this.counted_lokacije_platformi = {}
      this.counted_tip_platformi = {}
      unique_filtrirane_platforme.forEach(el => {
          this.platforme_dict[el.uuid_platforma] = el
            
          if(el.platforma_lokacija in this.counted_lokacije_platformi)
          {
            this.counted_lokacije_platformi[el.platforma_lokacija] += 1
          }
          else{
            this.counted_lokacije_platformi[el.platforma_lokacija] = 1
          }     
          if(el.platforma_tip_medija in this.counted_tip_platformi)
          {
            this.counted_tip_platformi[el.platforma_tip_medija] += 1
          }
          else{
            this.counted_tip_platformi[el.platforma_tip_medija] = 1
          }     
        });
      

      
      this.top_negatori = this.sort_by_key(this.counted_negatori, this.negatori_dict, 'negator_ime_naziv')
      

      /* sorting platforme */
      this.top_platforme = this.sort_by_key(this.counted_platforme, this.platforme_dict, 'platforma_naziv')
      
      /* sorting lokacije */
      this.top_lokacije = this.sort_by_value(this.counted_lokacije)
      /* sorting nacini */
      this.nacini_negiranja = this.sort_by_value(this.counted_nacini)        

      this.lokacije_negatora = this.sort_by_value(this.counted_lok_negatora)

      /* sorting sekt negatora */

      this.sektori_negatora = this.sort_by_value(this.counted_sektor_negatora)

      
      /* sorting oblast negatora */

      this.oblast_negatora = this.sort_by_value(this.counted_oblast_negatora)

      /* sorting lok platformi */
      this.lokacije_platformi = this.sort_by_value(this.counted_lokacije_platformi)

      /* sorting tip platformi */
      this.tip_platformi = this.sort_by_value(this.counted_tip_platformi)
      /**
       * go through cinovi, keep only ovi koji su po datumu
       * go through negatori, platforme, keep only ovi koji su u spisku
       * 
       * 
       */

    },
    start_resort: async function()
    {
      this.resort_by_date()
      await new Promise(r => setTimeout(r, 2000));
      this.show_all_graphs = true
    }
  },
  watch: {
    show_all_graphs: function()
    {
      this.show_top_negatori = this.show_all_graphs
      this.show_top_platforme = this.show_all_graphs        
      this.show_top_lokacije = this.show_all_graphs
      this.show_top_nacini = this.show_all_graphs
      this.show_lokacije_negatora = this.show_all_graphs
      this.show_sektori_negatora = this.show_all_graphs
      this.show_oblasti_negatora = this.show_all_graphs        
      this.show_lokacije_platformi = this.show_all_graphs
      this.show_tip_platformi = this.show_all_graphs
    }
  }
};
</script>
